<template>
  <div class="headerbar-container">
    <div class="headerbar-logo">
      <img src="@/assets/image/logo.png" />
    </div>
    <div class="a"><breadcrumb></breadcrumb></div>
    <!-- <div class="headerbar-userinfo">
        <div class="headerbar-userinfo-headimage">
          <img :src="userinfo.headimage" />
        </div>
    </div> -->
    <el-dropdown class="headerbar-userinfo">
      <!-- <div style="flex: 1"></div> -->
      <div class="userinfo el-dropdown-link">
          <div style="flex: 1"></div>
        <div class="userinfo-headimage">
          <img :src="userinfo.headimage" />
        </div>
        <div class="headerbar-info">
          <span class="headerbar-info-storename">{{ userinfo.storename }}</span>
          <span class="headerbar-info-username">
            {{ userinfo.nickName }}
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>
        
      </div>
      <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item>后台中心</el-dropdown-item>
          <el-dropdown-item>用户信息</el-dropdown-item> -->
          <!-- <el-dropdown-item divided> -->
             <el-dropdown-item >
            <span style="display: block" @click="logout()">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import Breadcrumb from "./breadcrumb";
import cookies from 'js-cookie'
import store from '@/store'

export default {
  components: { Breadcrumb },
  data() {
    return {
      userinfo: {
        headimage: "http://image.idaojia.net/images/employee/1600930852014.jpg",
        nickName: "111",
      },
    };
  },
  created(){
      // console.log(cookies.get('employee'));
    var employee = cookies.getJSON('employee');
    this.userinfo.storename = employee.storename;
    this.userinfo.nickName = employee.nickname;
  },
  methods: {
    logout: function() {
      store.dispatch("Logout").then(() => {
        location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.headerbar-container {
  height: 100%;
  width: 100%;
  display: flex;
  .headerbar-logo {
    height: 50px;
    width: 199px;
    border-right: 1px solid #ebeef5;
    text-align: center;
    img {
      // width: 100%;
      height: 100%;
    }
  }
  .a {
    flex: 1;
  }
  .headerbar-userinfo {
    width: 250px;
    text-align: right;
    //   padding: 0px 10px 0px 0px;
    display: flex;
    flex-direction: row;
    .userinfo {
        width: 100%;
      display: flex;
      text-align: right;
      .userinfo-headimage {
        width: 50px;
        height: 50px;
        img {
          width: 40px;
          height: 40px;
          margin: 5px 5px 5px 5px;
          border-radius: 5px;
        }
      }
      .headerbar-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 5px 10px 5px 0px;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/headerbar/index.vue